module.exports = __webpack_public_path__ + "img/phone_fill.dd236d96.svg";